import {useNavigate, Link} from 'react-router-dom';
import { useStyle } from '../../context/styleContext/styleContext';

export default function Footer(){

    const { style, setStyle } = useStyle();
    var yearDisplayString = ""
    const startYear = '2025'
    const curDateTime = new Date()
    const curYear = curDateTime.getFullYear()
    
    if(startYear == curYear)
        {
            yearDisplayString = startYear + " - "
        }
    else
        {
            yearDisplayString = startYear + " - " + curYear
        }


    return (
    <>
    <footer className="footer" style={{backgroundColor:style.color1, color:style.color4, width:'100%', marginBottom:'0px'}}>
        <div style={{margin:'auto', width:'90%', textAlign:'center', padding:'5px'}}>
            <div>
            <Link to='/' style={{className:'headerLinkText', fontSize:'.9em', textDecoration:'none', fontWeight:'bold', textAlign:'center', marginLeft:'10px', marginRight:'10px', color:style.color4}}>Home</Link>
            <Link to='/plugins' style={{fontSize:'.9em', fontWeight:'bold', textAlign:'center', marginLeft:'10px', marginRight:'10px', color:style.color4}}>Plugins</Link>
            <Link to='/support' style={{fontSize:'.9em', fontWeight:'bold', textAlign:'center', marginLeft:'10px', marginRight:'10px', color:style.color4}}>Support</Link>
            <Link to='/privacy-policy' style={{fontSize:'.9em', fontWeight:'bold', textAlign:'center', marginLeft:'10px', marginRight:'10px', color:style.color4}}>Privacy Policy</Link>
            </div>
            <div>
            <Link to='/contact' style={{fontSize:'.9em', textDecoration:'none', fontWeight:'bold', textAlign:'center', marginLeft:'10px', marginRight:'10px', color:style.color4}}>Contact</Link>
            <Link to='/about' style={{fontSize:'.9em', textDecoration:'none', fontWeight:'bold', textAlign:'center', marginLeft:'10px', marginRight:'10px', color:style.color4}}>About</Link>
            <Link to='/faq' style={{fontSize:'.9em', textDecoration:'none', fontWeight:'bold', textAlign:'center', marginLeft:'10px', marginRight:'10px', color:style.color4}}>FAQ</Link>
            <Link to='/learning' style={{fontSize:'.9em', textDecoration:'none', fontWeight:'bold', textAlign:'center', marginLeft:'10px', marginRight:'10px', color:style.color4}}>Learn</Link>
            <Link to='/terms' style={{fontSize:'.9em', textDecoration:'none', fontWeight:'bold', textAlign:'center', marginLeft:'10px', marginRight:'10px', color:style.color4}}>Terms & Conditions</Link>
            </div>
            <p style={{marginTop:'5px', marginBottom:'0px'}}>&copy; {yearDisplayString} Parish Audio -  All rights reserved.</p>
        </div>  


    </footer>
    
    </>)
}
